/*
 * @Author: yn
 * @Date: 2026-08-20 09:29:32
 * @LastEditors: yn
 * @LastEditTime: 2026-08-20 09:31:07
 * @Description: 历史动销奖励解冻
 */

import BasePage from '@/found/components/table_page';
import { ProcessLog } from '@/found/modules';

export default {
  name: 'history_sales_reward_unfreeze',
  extends: BasePage,
  components: {
    ProcessLog,
  },
  data() {
    return {};
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {
    clickVisible({ row, val: { code } }) {
      const { approveStatus, processCode } = row;

      if (code === 'process_log' && !processCode) {
        return false;
      }

      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processCode },
        };

        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
